import { render, staticRenderFns } from "./briefTrainingReport.vue?vue&type=template&id=ed0449cc&scoped=true"
import script from "./briefTrainingReport.vue?vue&type=script&lang=js"
export * from "./briefTrainingReport.vue?vue&type=script&lang=js"
import style0 from "./briefTrainingReport.vue?vue&type=style&index=0&id=ed0449cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed0449cc",
  null
  
)

export default component.exports